import React, { Fragment, useEffect, useState, forwardRef } from "react";
import { useAuth } from "../context/AuthContext";
import AsyncSelect from "react-select/async";

const DropDownUserStatusSelection = forwardRef(({
  defaultValue,
  onSelected,
  disabled = false,
  placeholderText = "Select Status",
}, ref) => {
  const { authAxios } = useAuth();
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    // Auto-select ACTIVE on initial load
    if (defaultValue === undefined) {
      const defaultOption = { value: "ACTIVE", label: "ACTIVE" };
      setSelected(defaultOption);
      onSelected("ACTIVE");
    }
  }, []);

  useEffect(() => {
    if (defaultValue === null || defaultValue === undefined) return;
    setSelected({ value: defaultValue, label: defaultValue });
  }, [defaultValue]);

  const fetchStatuses = async () => {
    try {
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };

      const response = await authAxios().get(
        "/api/backoffice/users/status",
        config,
      );
      
      // Map statuses to react-select format
      const options = response.data.map(status => ({
        value: status,
        label: status
      }));
      
      return options;
    } catch (error) {
      console.log("Error fetching user statuses");
      console.log(error);
      console.log(error.stack);
    }
    return [];
  };

  const selectStatus = (statusOption) => {
    if (statusOption === null) {
      // If selection is cleared, default back to ACTIVE
      const defaultOption = { value: "ACTIVE", label: "ACTIVE" };
      setSelected(defaultOption);
      onSelected("ACTIVE");
    } else {
      setSelected(statusOption);
      onSelected(statusOption?.value);
    }
  };

  const promiseOptions = () =>
    new Promise((resolve) => {
      setTimeout(() => {
        resolve(fetchStatuses());
      }, 300);
    });

  // Expose methods to the parent component via ref
  React.useImperativeHandle(ref, () => ({
    reset: () => {
      const defaultOption = { value: "ACTIVE", label: "ACTIVE" };
      setSelected(defaultOption);
      onSelected("ACTIVE");
    }
  }));

  return (
    <Fragment>
      <AsyncSelect
        className={"fs-input"}
        cacheOptions
        loadOptions={promiseOptions}
        defaultOptions={true}
        isClearable={true}
        onChange={(data) => {
          selectStatus(data);
        }}
        value={selected}
        placeholder={placeholderText}
        isDisabled={disabled}
      />
    </Fragment>
  );
});

export default DropDownUserStatusSelection;
